import './styles/App.css';
import React
	from "react";
import AppRouter
	from "./routes/router";
import {I18nextProvider} from 'react-i18next';
import i18n
	from './i18n/i18n';
import {DataProvider} from "./store/DataProvider";

function App() {
	return (
			<DataProvider>
				<I18nextProvider i18n={i18n}>
					<div className="container-fluid h-100">
						<AppRouter />
					</div>
				</I18nextProvider>
			</DataProvider>

	);
}

export default App;
